import { Button, ButtonGroup } from "@shopify/polaris";
import { t } from "i18next";
import Modal from "../Modal";
import React from "react";
import { useSelector } from "react-redux";
import { logout } from "../../redux/features/auth/authSlice";
import useAppDispatch from "hooks/useAppDispatch";
import { useNavigate } from "react-router";
import { getLoginUrl } from "utils/environment";
import { clearAuthClientState } from "utils/cookie";

const redirectToLogin = (navigate) => {
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "[::1]" ||
    /\.local$/.test(window.location.hostname);

  if (isLocalhost) {
    navigate("/login");
    setTimeout(() => {
      window.location.href = "/login";
    }, 100);
    return;
  }

  window.location.replace(getLoginUrl());
};

const LogoutModal = ({ visible, onClose }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loggingOut } = useSelector((state) => state.auth);

  const onLogout = () => {
    dispatch(logout());
    clearAuthClientState();
    dispatch({ type: "RESET_STORE" });
    redirectToLogin(navigate);
  };

  return (
    <Modal
      title={t("profile.logOut")}
      visible={visible}
      contentOnCenter
      onClose={onClose}
      iconType={"warning"}
      description={t("profile.sureLogout")}
      footer={
        <ButtonGroup fullWidth>
          <Button size="large" onClick={onClose}>
            {t("profile.no")}
          </Button>
          <Button
            variant="primary"
            tone="critical"
            size="large"
            onClick={onLogout}
            loading={loggingOut}
          >
            {t("profile.yes")}
          </Button>
        </ButtonGroup>
      }
    />
  );
};

export default LogoutModal;
